import { render } from "./Negocio.vue?vue&type=template&id=904b3ebe&scoped=true"
import script from "./Negocio.vue?vue&type=script&lang=js"
export * from "./Negocio.vue?vue&type=script&lang=js"

import "./Negocio.vue?vue&type=style&index=0&id=904b3ebe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-904b3ebe"]])

export default __exports__